import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_V2 } from '../api.conf';

import { CustomerResponseDTO } from '../../dto/response';
import { CustomerRequestDTO } from '../../dto/request';

@Injectable()
export class CustomerApiService {
  constructor(private http: HttpClient, @Inject(API_V2) private api: string) {}

  private get basePath() {
    return `${this.api}/public`;
  }

  getCurrentCustomer(companyUuid: string): Observable<CustomerResponseDTO> {
    return this.http.get<CustomerResponseDTO>(`${this.basePath}/companies/${companyUuid}/customers/current`);
  }

  updateCurrentCustomer(companyUuid: string, payload: CustomerRequestDTO): Observable<CustomerResponseDTO> {
    return this.http.put<CustomerResponseDTO>(`${this.basePath}/companies/${companyUuid}/customers/current`, payload);
  }
}
